export class UserPreSharedKeyResponse {
  AuthenticationCode: string;
  PreSharedKey: string;

  constructor(authenticationCode: string, preSharedKey: string) {
    this.AuthenticationCode = authenticationCode;
    this.PreSharedKey = preSharedKey;
  }
}